
    import './styles.scoped.css';
    export default {
  "drag-overlay": "awsui_drag-overlay_hqft4_l5bla_145"
};
  